import React from "react";

const PreviousIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8.214"
      height="13.6"
      viewBox="0 0 8.214 13.6"
    >
      <path
        id="Path_289"
        data-name="Path 289"
        d="M5964.578-2430.784l6.093,6.093-6.093,6.093"
        transform="translate(5972.085 -2417.891) rotate(180)"
        fill="none"
        stroke={fill ? fill : "#404040"}
        strokeWidth="2"
      />
    </svg>
  );
};

export default PreviousIcon;
